<template>
    <div class="tender-result-upload">
        <el-table :data="tableData" stripe border v-loading="loading" style="width: 100%">
            <el-table-column prop="fileName" label="附件名称"></el-table-column>
            <el-table-column prop="uploadFileName" label="上传附件名称">
                <template v-slot="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.uploadFileFullName"
                        placement="top-start">
                        <span>{{ scope.row.uploadFileName }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template v-slot="scope">
                    <el-button @click="onPreview(scope.row)" type="text" size="small">预览</el-button>
                    <el-button @click="onDownload(scope.row)" type="text" size="small">下载</el-button>
                </template>
            </el-table-column>
        </el-table>
        <Preview v-if="attachmentShow" :attachmentShow.sync="attachmentShow" :rowData="previewData" />
    </div>
</template>
<script>
import Preview from '../../../../lsrm/components/viewAttachment.vue'
import { uplaodQueryByBidNo } from '../../../api/tenderOffer/tenderCostDetails.js'

export default {
    components: { Preview },
    data() {
        return {
            loading: false,
            attachmentShow: false,
            previewData: {},
            tableData: [
                {
                    fileName: '招标现场签到表',
                    uploadName: 'uploadSignIn',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '301',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                },
                {
                    fileName: '招标现场记录表',
                    uploadName: 'uploadRecords',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '302',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                },
                {
                    fileName: '测算表',
                    uploadName: 'uploadCalculation',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '303',
                    transportDownload: '303',
                    loadingUnloadingDownload: '304',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                },
                {
                    fileName: '招标/议价总结报告',
                    uploadName: 'uploadBargaining',
                    uploadFileName: '',
                    state: false,
                    fileAttribute: '305',
                    uploadFileFullName: '',
                    uploadDate: '',
                    uploadId: '',
                    downLoadUrl: '',
                    fileSuffix: '',
                },
            ],
            // uploadData: {},
            // headInfo: '',
            // dictData: [],
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            let params = {
                bidNo: this.$route.query.formInstanceId,
            }
            this.loading = true
            uplaodQueryByBidNo(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        const { bidOnSiteRecodeAttrInfo, bidOnSiteSignInAttrInfo, measureAttrInfo, summaryAttrInfo } =
                            res.data
                        for (const item of this.tableData) {
                            if (item.uploadName === 'uploadSignIn' && bidOnSiteSignInAttrInfo) {
                                //招标现场签到表
                                let fullName = bidOnSiteSignInAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (bidOnSiteSignInAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = bidOnSiteSignInAttrInfo.downLoadUrl
                                item.fileSuffix = bidOnSiteSignInAttrInfo.fileSuffix
                                item.uploadDate = bidOnSiteSignInAttrInfo.updateTime
                            } else if (item.uploadName === 'uploadRecords' && bidOnSiteRecodeAttrInfo) {
                                //招标现场记录表
                                let fullName = bidOnSiteRecodeAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (bidOnSiteRecodeAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = bidOnSiteRecodeAttrInfo.downLoadUrl
                                item.fileSuffix = bidOnSiteRecodeAttrInfo.fileSuffix
                                item.uploadDate = bidOnSiteRecodeAttrInfo.updateTime
                            } else if (item.uploadName === 'uploadCalculation' && measureAttrInfo) {
                                //测算表
                                let fullName = measureAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (measureAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = measureAttrInfo.downLoadUrl
                                item.fileSuffix = measureAttrInfo.fileSuffix
                                item.uploadDate = measureAttrInfo.updateTime
                            } else if (item.uploadName === 'uploadBargaining' && summaryAttrInfo) {
                                //招标/议价总结报告
                                let fullName = summaryAttrInfo.fileName
                                let newName = this.setFileName(fullName)
                                item.uploadFileName = newName
                                item.uploadFileFullName = fullName
                                if (summaryAttrInfo.downLoadUrl) {
                                    item.state = true
                                }
                                item.downLoadUrl = summaryAttrInfo.downLoadUrl
                                item.fileSuffix = summaryAttrInfo.fileSuffix
                                item.uploadDate = summaryAttrInfo.updateTime
                            }
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setFileName(fullName) {
            let newName = fullName
            let nameList = fullName.split('.')
            if (nameList[0] && nameList[0].length > 20) {
                let beforName = nameList[0].substring(0, 20)
                newName = `${beforName}....${nameList[nameList.length - 1]}`
            }
            return newName
        },
        //下载
        onDownload(row) {
            const { downLoadUrl, uploadFileFullName } = row
            if (!downLoadUrl) {
                this.$message.warning('下载地址无效')
                return
            }
            const a = document.createElement('a')
            a.style.display = 'none'
            a.download = `${uploadFileFullName}`
            a.href = downLoadUrl
            a.click()
            document.body.removeChild(a)
        },
        onPreview(row) {
            this.attachmentShow = true
            this.previewData = { downUrl: row.downLoadUrl }
        },
    },
}
</script>
<style lang="less" scoped>
.tender-result-upload {
    margin: 0 20px;
}
</style>
